import { isMobileDevice } from "../utils/detectBrowser";
import { useLayoutEffect } from "react";
import { usePathname } from "next/navigation";

const restoreScrollPosition = (pagePath) => {
  const storedPositionJson = sessionStorage.getItem(`scroll:${pagePath}`);
  if (!storedPositionJson) return;

  const storedPosition = JSON.parse(storedPositionJson);
  if (!storedPosition) return;

  const element = document.querySelector(
    `[data-scroll-id="${storedPosition.id}"]`,
  );

  if (element) {
    if (isMobileDevice) {
      setTimeout(() => {
        element.scrollIntoView({ block: 'center' });
      }, 50);
      return;
    }

    element.scrollIntoView({ block: 'center' });
  }
};

const clearScrollPosition = (pagePath) => {
  sessionStorage.removeItem(pagePath);
};

export const useScrollRestoration = ({ isSSR, disable }) => {
  const pagePath = usePathname();

  const registerScrollPosition = ({ element }) => {
    const scrollId = element.dataset.scrollId;

    if (!scrollId) {
      console.error('[data-scroll-id] is not defined on element');
      return;
    }

    const { top } = element.getBoundingClientRect();
    sessionStorage.setItem(
      `scroll:${pagePath}`,
      JSON.stringify({ id: scrollId, top }),
    );
  };

  useLayoutEffect(() => {
    if (isSSR || disable) return;
    if ('scrollRestoration' in window.history) {
      restoreScrollPosition(pagePath);
      clearScrollPosition(pagePath);
    }
  }, [isSSR]);

  return {
    registerScrollPosition,
  };
};
